module.exports = __webpack_public_path__ + "static/img/Jake-Lloyd.69d4818.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jake-Lloyd.jpg
// module id = 6F64
// module chunks = 0